import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Table.css';

class Table1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
    };
  }

  handleChangePage = (newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  render() {
    const { data } = this.props;
    const { page, rowsPerPage } = this.state;

    if (!Array.isArray(data)) {
      return <div>Data is not an array or is undefined</div>;
    }

    const pagesCount = Math.ceil(data.length / rowsPerPage);

    return (
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Family Name</th>
              <th>Name</th>
              <th>Email</th>
              <th>Zone Info</th>
            </tr>
          </thead>
          <tbody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
              <tr key={row.id}>
                <td>{row.profile.family_name}</td>
                <td>{row.profile.name}</td>
                <td>{row.profile.email}</td>
                <td>{row.profile.zoneinfo}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="pagination-controls">
          <button
            onClick={() => this.handleChangePage(page - 1)}
            disabled={page === 0}
          >
            Previous
          </button>
          <span>
            Page {page + 1} of {pagesCount}
          </span>
          <button
            onClick={() => this.handleChangePage(page + 1)}
            disabled={page >= pagesCount - 1}
          >
            Next
          </button>
          <select value={rowsPerPage} onChange={this.handleChangeRowsPerPage}>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>
    );
  }
}

Table1.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Table1;



// WEBPACK FOOTER //
// ./src/components/pages/Table1.js